import { render, staticRenderFns } from "./LunchListAggregateRow.vue?vue&type=template&id=225f2344&"
import script from "./LunchListAggregateRow.vue?vue&type=script&lang=js&"
export * from "./LunchListAggregateRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports